import request from '@/utils/request';

export const GetVmiTransferByVmiId = parameter => request.get('/vmi/get-vmi-transfer-by-vmi-id', { params: parameter });

export const GetVmiTransferList = parameter => request.post('/vmi/select-vmi-transfer-by-criterion-bean-vo',  parameter);